import angular from 'angular';

class adminCreationErrorModalCtrl {
  /* @ngInject */
  constructor() {}
  $onInit() {}

  close() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('adminCreationErrorModal', {
  templateUrl: require('./admin-creation-error-modal.html'),
  controller: adminCreationErrorModalCtrl,
  bindings: {
    modalInstance: '<'
  }
});
